import * as THREE from 'three';

THREE.Reticle = function(camera) {

    var reticle = {};

    reticle.armObject = null;
    reticle.reticleObject = null;
    reticle.dot = null;
    reticle.intersection = null;
    reticle.colliders = [];

    const defaultMaterial = new THREE.MeshBasicMaterial({color: '#a9a9a9',transparent: true,opacity: 0 });
    const hitMaterial = new THREE.MeshBasicMaterial({color: '#ff0000',transparent: true,opacity: 0.7 });

    reticle.createDefaultObject = function(position, length, isDot) {
        if (isDot) {
            var defaultGeometry = new THREE.SphereGeometry(0.007, 32, length);
        } else {
            var defaultGeometry = new THREE.TorusGeometry( 0.2, 0.04, 16, 100 );
        }
        var defaultObject = new THREE.Mesh(defaultGeometry, defaultMaterial);
        defaultObject.position.copy(position);
        defaultObject.rotation.x = -Math.PI * 0.5;
        return defaultObject;
    };

    reticle.init = function(camera) {
        this.camera = camera;
        this.armObject = new THREE.Object3D();
        this.reticleObject = this.createDefaultObject(new THREE.Vector3(0, 0, -0.5), .01, false);
        this.armObject.add(this.reticleObject);

        this.dot = this.createDefaultObject(new THREE.Vector3(0, 0, -0.5), .01, true);
        this.camera.add(this.armObject);
        this.camera.add(this.dot);
        this.startClock();
    };

    reticle.getReticlePosition = function() {
        return reticle.reticleObject.position;
    };

    reticle.remvoeFromList = function(object_in, list_in) {
        var index = list_in.indexOf(object_in);
        if (index > -1) {
            list_in.splice(index, 1);
        }
    };

    reticle.addCollider = function(threeObject) {
        this.colliders.push(threeObject);
    };

    reticle.removeCollider = function(threeObject) {
        this.remvoeFromList(threeObject, reticle.colliders);
    };

    reticle.update = function(parent) {
        var camDirection = new THREE.Vector3();
        this.camera.getWorldDirection( camDirection );
        var ray = new THREE.Raycaster(this.camera.position, camDirection);


        var intersects = ray.intersectObjects(this.colliders);
        if (intersects.length > 0) {
            //save the new hit object and time
            this.intersection = intersects[0];
            this.reticleObject.position.copy(this.intersection.point);
            if(parent) this.reticleObject.position.sub(parent.position);

            this.reticleObject.material = hitMaterial;
            this.dot.material.opacity = 0;

        } else {
            this.dot.material.opacity = 1;
            this.reticleObject.material = defaultMaterial;
        }
    }

    reticle.startClock = function() {
        this.clock = new THREE.Clock(true);
    }

    reticle.init(camera);

    return reticle;
}



// WEBPACK FOOTER //
// ./src/translators/utils/reticle.js